import styled, { createGlobalStyle } from "styled-components";
import Variables from "../../assets/styleVariables";
import {
  ADD_BUTTON_HEIGHT,
  CLOSED_SIDEBAR_WIDTH,
  EXPANDED_SIDEBAR_WIDTH,
  HEADER_BAR_HEIGHT
} from "../../constants/fixedStyleVariables";

const FOOTER_HEIGHT = 104;
export const Sidebar = styled.div`
  z-index: 9999;
  position: fixed;
  top: ${HEADER_BAR_HEIGHT}px;
  height: calc(100vh - ${HEADER_BAR_HEIGHT}px);
  max-height: calc(100vh - ${HEADER_BAR_HEIGHT}px);
  overflow-y: auto;
  right: 0;
  padding-top: 85px;
  ${props => {
    if (props.expand) {
      return ` width: ${EXPANDED_SIDEBAR_WIDTH}px; `;
    } else {
      return `
            width: ${CLOSED_SIDEBAR_WIDTH}px;
            span.list-item-text {
                display: none !important;
            }
      `;
    }
  }};
  background-color: ${Variables.colors.complementary};
  border-left: 1px solid ${Variables.colors.complementary_400};
  direction: ltr;
  text-align: right;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ul.sidebar-list {
    ${props => {
      if (props.expand) {
        return `
					padding: 13px 0 0 8px;
					margin: 8px 0 0 0;
				`;
      } else {
        return `
					margin: 8px auto 0 auto;
    			    padding: 13px 0 0 0;
				`;
      }
    }};

    direction: rtl;
  }
  .sidebar-footer {
    margin-right: 12px;
    padding: 20px 16px 10px 4px;
    direction: rtl;
    text-align: right;
    background-color: ${Variables.colors.complementary};
    .panel-link {
      text-decoration: none;
      color: ${Variables.colors.complementary_600};
      cursor: pointer;
      &:hover,
      &:visited,
      &:focus {
        color: ${Variables.colors.complementary_600};
      }
    }
    a {
      text-decoration: none;
      color: ${Variables.colors.complementary_600};
      &:hover,
      &:visited,
      &:focus {
        color: ${Variables.colors.complementary_600};
      }
    }
    .circle-separator {
      width: 4px;
      height: 4px;
      display: inline-block;
      vertical-align: middle;
      margin: 0 2px;
      content: " ";
      border-radius: 50%;
      background-color: ${Variables.colors.complementary_700};
    }
    .copyright {
      line-height: normal;
      color: ${Variables.colors.complementary_500};
      font-size: ${Variables.font_sizes.small};
      font-weight: ${Variables.font_weight.light};
    }
    div {
      ${props => {
        if (props.expand) {
          return `
                color: ${Variables.colors.complementary_600};
                font-size: ${Variables.font_sizes.x_small};
                padding-bottom: 7px;
            `;
        } else {
          return `
                display: none;
            `;
        }
      }}
    }
    .minimum-mode-icon {
      a {
        i {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          &:before {
            color: ${Variables.colors.complementary_600};
            margin-left: 0;
          }
          &:hover {
            background-color: ${Variables.colors.complementary_200};
          }
        }
      }
      ${props => {
        if (props.expand) {
          return `display: none;`;
        } else {
          return `display: block;`;
        }
      }}
    }
  }
  @media (max-width: 1199px) {
    ${props => {
      if (!props.expand) {
        return `
              & {
                  width: ${CLOSED_SIDEBAR_WIDTH}px;
                  span.list-item-text {
                      display: none !important;
                  }
                  
                  ul.sidebar-list {
                      margin: 16px auto 0 auto;
                      padding: 12px 0 0 0;
                      
                  }
              }
              .sidebar-footer {
                  div {
                      display: none;
                  }
                  .minimum-mode-icon {
                      display: block;
                  }
              }
        `;
      }
    }}
  }
`;

export const DashboardBody = styled.div`
  margin-top: ${HEADER_BAR_HEIGHT}px;
  background-color: ${Variables.colors.complementary};
  //max-height: calc(100vh - 65px);
  //overflow-y: auto;
  ${props => {
    if (props.expand) {
      return `
            margin-right: ${EXPANDED_SIDEBAR_WIDTH}px;
      `;
    } else {
      return `
            margin-right: ${CLOSED_SIDEBAR_WIDTH}px;
      `;
    }
  }}

  .dashboard-container {
    width: 100%;
    //min-height: calc(10-y0vh - 64px);
    height: auto;
  }
  @media (max-width: 1199px) {
    ${props => {
      if (!props.expand) {
        return `
              & {
                  margin-right: ${CLOSED_SIDEBAR_WIDTH}px;
              }
        `;
      }
    }}
  }
`;

export const GlobalStyle = createGlobalStyle`
	html{
      overflow-y: hidden;
      height: 100vh;
	}
	body{
      background-color: ${Variables.colors.complementary};

      height: 100vh;
	}
	input::-ms-clear {
    display: none;
    height: 0;
    width: 0;
    visibility: hidden;
  }
`;
